import { Dispatch } from 'redux';
import { getAircraftLogs } from '../../services/api';
import { AircraftLogbookActionTypes } from '.';

// eslint-disable-next-line import/prefer-default-export
export const fetch =
  ({ payload }: { payload: { aircraft: number; from: string; to: string; columns: string[] } }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await getAircraftLogs(payload);
    if (response?.length) {
      dispatch({
        type: AircraftLogbookActionTypes.SAVE,
        payload: response[0],
      });
    } else {
      dispatch({
        type: AircraftLogbookActionTypes.SAVE,
        payload: response,
      });
    }
  };
